import * as React from "react";

import { NavigationBar } from "../Common";

import { ContentRoutes, useContentRoute } from "./providers";

import { Header } from "./header";
import { PurchasePage } from "./purchase-page";
import { CheckBalancePage } from "./check-balance-page";

export const Page: React.FunctionComponent = () => {
  const {
    hasInitialized,
    selectedContentRoute,
    onUserWantsToSelectContentRoute,
  } = useContentRoute();

  return (
    <section className="bbnt-giftcards-page-section">
      <Header />
      {hasInitialized && (
        <React.Fragment>
          <NavigationBar
            ContentRoutes={ContentRoutes}
            selectedContentRoute={selectedContentRoute}
            onUserWantsToSelectContentRoute={
              onUserWantsToSelectContentRoute as (route: string) => void
            }
          />
          {selectedContentRoute === ContentRoutes.Purchase && <PurchasePage />}
          {selectedContentRoute === ContentRoutes.CheckBalance && (
            <CheckBalancePage />
          )}
        </React.Fragment>
      )}
    </section>
  );
};
